const nlBlogIsde = {
  meta: {
    title: "ISDE-subsidie 2026 | Complete Gids Ramen & Glas",
    description:
      "Alles over de ISDE-subsidie 2026 voor energiezuinige ramen, HR++ glas en isolatie. Bedragen, voorwaarden en hoe u aanvraagt.",
  },
  hero: {
    h1: "ISDE-subsidie 2026 : de complete gids voor ramen en glas",
    subtitle:
      "Investeer in energiezuinige ramen en HR++ beglazing en ontvang tot duizenden euros subsidie. Wij leggen alle regels, bedragen en stappen uit.",
    image:
      "/img/05-home-newly-installed-energy.jpg",
    updated: "Laatst bijgewerkt mei 2026",
    readTime: "8 min leestijd",
  },
  toc: {
    title: "Inhoudsopgave",
    items: [
      "Wat is de ISDE-subsidie ?",
      "ISDE-subsidie 2026 : bedragen voor glas en ramen",
      "Voorwaarden ISDE-subsidie 2026",
      "Hoe vraagt u ISDE-subsidie aan ?",
      "ISDE combineren met andere subsidies",
      "Wij helpen u gratis met de aanvraag",
      "Veelgestelde vragen",
    ],
  },
  sections: {
    watIs: {
      h2: "Wat is de ISDE-subsidie ?",
      p1: "De ISDE-subsidie staat voor Investeringssubsidie Duurzame Energie en Energiebesparing. Deze subsidie is bedoeld voor particulieren die hun woning willen verduurzamen. De overheid stelt elk jaar miljoenen euros beschikbaar om de energietransitie te versnellen.",
      p2: "In 2026 blijft de ISDE-subsidie een belangrijk instrument voor woningeigenaren. De subsidie dekt onder andere de kosten van energiezuinige ramen, HR++ beglazing, triple glas en andere isolatiemaatregelen. Door de stijgende energieprijzen is investeren in isolatie lucratiever dan ooit.",
      p3: "De ISDE-subsidie wordt toegekend door de Rijksdienst voor Ondernemend Nederland (RVO). U vraagt de subsidie aan na uitvoering van de werkzaamheden. Het subsidiebedrag wordt vastgesteld op basis van het type maatregel en de oppervlakte.",
    },
    bedragen: {
      h2: "ISDE-subsidie 2026 : bedragen voor glas en ramen",
      intro:
        "De subsidiebedragen voor 2026 zijn aantrekkelijk voor zowel kleine als grote projecten. Hieronder een overzicht van de belangrijkste bedragen voor ramen en glas.",
      tableHead: ["Maatregel", "Subsidiebedrag per m²", "Opmerking"],
      tableRows: [
        [
          "HR++ glas (isolatieglas)",
          "€ 35 – € 65 per m²",
          "Afhankelijk van het type woning en combinatie",
        ],
        [
          "Triple glas",
          "€ 55 – € 90 per m²",
          "Hoger bedrag dan HR++ vanwege betere isolatiewaarde",
        ],
        [
          "Kozijn + HR++ glas (combinatie)",
          "€ 75 – € 125 per m²",
          "Combinatie subsidie bij volledige vervanging",
        ],
        [
          "Dakkapel isolatie",
          "€ 45 – € 70 per m²",
          "Inclusief Velux of dakraam met isolatieglas",
        ],
        [
          "Vloerisolatie (combinatie)",
          "€ 20 – € 35 per m²",
          "Combineer met glas voor hoger totaalbedrag",
        ],
      ],
      p1: "Bij grotere projecten — bijvoorbeeld de vervanging van alle ramen in een tussenwoning — kan de ISDE-subsidie oplopen tot duizenden euros. Een gemiddeld rijtjeshuis met 12 m² aan nieuw HR++ glas ontvangt al snel € 600 tot € 1.200 aan subsidie.",
      p2: "Het totale subsidiebedrag wordt berekend over de totale oppervlakte van het vervangen glas. Ook de vervanging van oude enkel glas door HR++ levert aanzienlijke subsidies op, omdat de energiebesparing maximaal is.",
    },
    voorwaarden: {
      h2: "Voorwaarden ISDE-subsidie 2026",
      intro:
        "Niet elke maatregel komt in aanmerking voor de ISDE-subsidie. Er gelden strikte voorwaarden die u moet kennen voordat u start.",
      items: [
        {
          title: "Eigenaar-bewoner",
          text: "U moet eigenaar én hoofdbewoner zijn van de woning waarin de maatregel wordt uitgevoerd. Huurwoningen en vakantiewoningen komen niet in aanmerking.",
        },
        {
          title: "Minimale oppervlakte glas",
          text: "Er geldt een minimumoppervlakte voor de te vervangen beglazing. Per aanvraag moet minimaal 2 m² aan glas vervangen worden.",
        },
        {
          title: "Erkend installateur vereist",
          text: "De werkzaamheden moeten uitgevoerd worden door een erkend bedrijf. Bij de aanvraag dient u een factuur en betaalbewijs te uploaden.",
        },
        {
          title: "Aanvraag binnen termijn",
          text: "De aanvraag moet ingediend worden binnen zes maanden na uitvoering van de maatregel. Wacht dus niet te lang na oplevering.",
        },
        {
          title: "Geen dubbele subsidie",
          text: "Voor dezelfde maatregel kunt u geen ISDE-subsidie én een gemeentelijke subsidie ontvangen, tenzij de gemeente expliciet toestaat dat u beide combineert.",
        },
      ],
    },
    hoeAanvragen: {
      h2: "Hoe vraagt u ISDE-subsidie aan ?",
      intro:
        "Het aanvragen van de ISDE-subsidie verloopt via mijn.rvo.nl. Volg deze stappen om zeker te zijn van een succesvolle aanvraag.",
      steps: [
        {
          num: "1",
          title: "Offerte + uitvoering erkend bedrijf",
          text: "Vraag een offerte aan bij een erkend installateur zoals Ramen Repair Eindhoven. Laat de werkzaamheden uitvoeren en bewaar alle facturen en betaalbewijzen.",
        },
        {
          num: "2",
          title: "Betaalbewijs en factuur bewaren",
          text: "U heeft een gedetailleerde factuur en een betaalbewijs nodig. De factuur moet specifiek vermelden welk type glas en welke oppervlakte is geplaatst.",
        },
        {
          num: "3",
          title: "Aanvraag via mijn.rvo.nl met DigiD",
          text: "Log in op mijn.rvo.nl met uw DigiD. Vul het aanvraagformulier in, upload de benodigde documenten en verstuur de aanvraag.",
        },
        {
          num: "4",
          title: "Uitbetaling binnen enkele weken",
          text: "Na goedkeuring ontvangt u het subsidiebedrag binnen 4 tot 8 weken op uw rekening. Bij vragen neemt de RVO contact met u op.",
        },
      ],
      tip: "Tip : start de aanvraag direct na oplevering. Het budget van de ISDE is jaarlijks beperkt en kan op raken.",
    },
    combineren: {
      h2: "ISDE combineren met andere subsidies",
      p1: "Naast de landelijke ISDE-subsidie zijn er ook gemeentelijke regelingen beschikbaar. In Eindhoven kunt u mogelijk profiteren van extra leningen of subsidies via de gemeente voor energiebesparende maatregelen.",
      p2: "Wij adviseren u graag over de mogelijkheden om subsidies te combineren. Soms is het voordeliger om eerst de gemeentelijke subsidie aan te vragen en vervolgens de ISDE-subsidie. Onze specialisten kennen de lokale regelingen en helpen u kiezen.",
      linkGlas: {
        text: "Bekijk onze glas vervangen service",
        href: "/glas-vervangen/",
      },
      linkKozijn: {
        text: "Bekijk onze kozijnreparatie service",
        href: "/kozijn-reparatie/",
      },
    },
    wijHelpen: {
      h2: "Wij helpen u gratis met de aanvraag",
      p1: "Bij Ramen Repair Eindhoven adviseren wij u niet alleen over het beste glas voor uw woning, maar helpen wij u ook bij het verzamelen van de benodigde documenten voor de ISDE-subsidie.",
      p2: "Wij zorgen voor een gedetailleerde factuur met alle specificaties die de RVO vereist. Ook beschrijven wij in onze offertes duidelijk welke maatregelen in aanmerking komen voor subsidie, zodat u direct na oplevering kunt starten met de aanvraag.",
      cta: "Energiezuinig glas met ISDE-subsidie ? Vraag gratis advies aan",
      phone: "040 798 7470",
    },
  },
  faq: {
    h2: "Veelgestelde vragen over ISDE-subsidie",
    items: [
      {
        q: "Hoeveel ISDE-subsidie krijg ik voor HR++ glas in 2026 ?",
        a: "Voor HR++ glas ontvangt u tussen de € 35 en € 65 per m² subsidie, afhankelijk van het type woning en of u meerdere maatregelen combineert. Bij een gemiddeld rijtjeshuis loopt dit al snel op tot € 600 – € 1.200.",
      },
      {
        q: "Kan ik ISDE-subsidie aanvragen voor kozijnvervanging ?",
        a: "Alleen de vervanging van kozijnen komt niet direct in aanmerking. Wel als u tegelijkertijd energiezuinig glas (HR++ of triple) plaatst in nieuwe kozijnen. De subsidie geldt dan voor de combinatie van glas en kozijn.",
      },
      {
        q: "Moet een erkend bedrijf het glas plaatsen ?",
        a: "Ja, voor de ISDE-subsidie moet het werk uitgevoerd worden door een erkend installateur. U heeft een factuur en betaalbewijs nodig. Wij voldoen aan alle eisen en leveren de juiste documentatie.",
      },
      {
        q: "Hoelang duurt de uitbetaling van de subsidie ?",
        a: "Na indiening van een complete aanvraag duurt de uitbetaling gemiddeld 4 tot 8 weken. In drukke periodes kan dit iets langer duren. De RVO stuurt een bericht zodra de aanvraag is goedgekeurd.",
      },
      {
        q: "Kan ik ISDE met gemeentesubsidie combineren ?",
        a: "In de meeste gevallen wel, mits de gemeente expliciet toestaat dat beide subsidies gecombineerd worden. Wij adviseren u graag over de specifieke regelingen in Eindhoven en omstreken.",
      },
    ],
  },
  disclaimer:
    "Subsidiebedragen en voorwaarden kunnen wijzigen. Raadpleeg altijd rvo.nl voor actuele informatie.",
  schema: {
    headline:
      "ISDE-subsidie 2026 : de complete gids voor ramen en glas",
    description:
      "Alles over de ISDE-subsidie 2026 voor energiezuinige ramen, HR++ glas en isolatie. Bedragen, voorwaarden en hoe u aanvraagt.",
    author: "Ramen Repair Eindhoven",
    datePublished: "2026-05-28",
    dateModified: "2026-05-28",
  },
};

export default nlBlogIsde;